// Vorschläge für „Verantwortlich“ an Schritten und Entscheidungen (gespeichert wird ein Name als Freitext).
import { useEffect, useMemo, useState } from 'react';
import { api, type Person } from '../api';
import { sync, darfOderSa } from '../sync';
import { useIch } from '../App';
import { verantwortliche } from '../logik/model.js';

/** Bereits verwendete Namen, dazu ich und die Projektmitglieder (Name, sonst E-Mail). */
export function useVerantwortlichVorschlaege(data: any): string[] {
  const { ich } = useIch();
  const [mitglieder, setMitglieder] = useState<Person[]>([]);
  useEffect(() => {
    if (!sync.projektId || !darfOderSa('mitwirkend', ich?.superadmin)) return;
    api.personen(sync.projektId).then((m) => setMitglieder(m.personen)).catch(() => { /* ohne Liste: bekannte Namen */ });
  }, [sync.projektId]);
  return useMemo(() => {
    const namen = new Map<string, string>();
    const dazu = (n: string | null | undefined) => {
      const v = (n || '').trim();
      if (v && !namen.has(v.toLowerCase())) namen.set(v.toLowerCase(), v);
    };
    for (const v of verantwortliche(data)) dazu(v.name);
    if (ich) dazu(ich.name || ich.email);
    for (const p of mitglieder) dazu(p.name || p.email);
    return [...namen.values()].sort((a, b) => a.localeCompare(b, 'de'));
  }, [data, mitglieder, ich]);
}
